import {useLocation} from 'react-router'

export function useNativeInfo() {
  const location = useLocation()
  const {pathname} = location

  const avoidLeftNavigationRoutes = ['/policies/', '/settings/']

  const isLeftNavHidden =
    //shoow left nav if route is included in avoidLeftNavigationRoutes + /**, hide if route is  if route is included in avoidLeftNavigationRoute but matches exactly
    pathname === '/settings/grant-access' ||
    !avoidLeftNavigationRoutes.some(
      route => pathname.includes(route) && pathname !== route,
    )

  return {pathname, isLeftNavHidden}
}
